import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import './mdtabs/primary-tab.js';

export class IxPrimaryTab extends LitElement {
  static styles = css`
    :host {
      display: flex;
      font-family: var(--text-heading-font, sans-serif);
      line-height: var(--text-heading-line-height, 1.2em);
      text-decoration: var(--text-heading-decoration, none);
      font-weight: var(--ix-button-font-weight, bold);
      text-transform: var(--ix-button-text-transform, uppercase);
      letter-spacing: var(--ix-button-letter-spacing, 1.25px);
      --md-icon-size: var(--ix-tab-icon-size, 20px);
    }
    [inline-icon] ::slotted([slot='icon']) {
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      justify-content: center;
      margin: var(--ix-tab-icon-margin, 0 -6px 0 0);
    }
    md-primary-tab {
      flex: 1 1 0%;
    }
  `;

  @property({ type: Boolean, reflect: true }) active = false;

  @property({ type: Boolean, attribute: 'inline-icon' }) inlineIcon = false;

  render() {
    return html`<md-primary-tab
      ?active=${this.active}
      ?inline-icon=${this.inlineIcon}
    >
      <slot slot="icon" name="icon"></slot>
      <slot></slot
    ></md-primary-tab> `;
  }
}
